import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Location } from "../models/location";

import { Observable } from "rxjs";
import { PagedData } from "../models/paging/paged-data";
import { Page } from "../models/paging/page";
import { ServerData } from "../models/paging/server-data";

import { AuthService } from "../services/auth.service";
import * as moment from "moment";
import { environment } from "../../environments/environment";
import { SnotifyService } from "ng-snotify";

@Injectable()
export class AuditReportService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private snotifyService: SnotifyService
  ) {}

  public getResults(
    page: Page,
    customer_Type_Id: number,
    company_Id: number,
    location_Id: number,
    pda_User_ID: number,
    start_Date: string,
    end_Date: string,
    is_Client: boolean,
    quick_Search: string
  ): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == "") {
        page.sortBy = "Inspected_At";
      }
      if (page.sortOrder == undefined || page.sortOrder == "") {
        page.sortOrder = "desc";
      }

      let params = "&customer_Type_Id=" + customer_Type_Id;
      params += "&company_Id=" + company_Id;
      params += "&location_Id=" + location_Id;
      params += "&start_Date=" + moment(start_Date).format("YYYY-MM-DD");
      params += "&end_Date=" + moment(end_Date).format("YYYY-MM-DD");

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += "&is_Client=" + is_Client;
      params += "&quick_Search=" + quick_Search;

      this.http
        .get<ServerData>(
          environment.apiUrl +
            "audit/GetTable?size=" +
            page.size +
            "&pageNumber=" +
            page.pageNumber +
            "&sortBy=" +
            page.sortBy +
            "&sortOrder=" +
            page.sortOrder +
            params
        )
        .subscribe(
          (data) => {
            page.totalElements = data.total;
            page.totalPages = page.totalElements / page.size;
            console.log(data);
            for (let i = 0; i < data.data.length; i++) {
              const jsonObj = data.data[i];
              pagedData.data.push(jsonObj);
            }

            pagedData.page = page;
            resolve(pagedData);
          },
          (error) => {
            reject();
          }
        );
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || "";
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType,
    }); //statement which creates the blob
    return blob;
  }

  public getExcel(
    customer_Type_Id: number,
    company_Id: number,
    location_Id: number,
    pda_User_ID: number,
    start_Date: string,
    end_Date: string,
    is_Client: boolean
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = "?customer_Type_Id=" + customer_Type_Id;
      params += "&company_Id=" + company_Id;
      params += "&location_Id=" + location_Id;
      params += "&start_Date=" + moment(start_Date).format("YYYY-MM-DD");
      params += "&end_Date=" + moment(end_Date).format("YYYY-MM-DD");

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += "&is_Client=" + is_Client;

      this.http
        .get<any>(environment.apiUrl + "audit/GetExcel" + params)
        .subscribe(
          (data) => {
            let blob = this.converBase64toBlob(
              data,
              "application/vnd.ms-excel"
            );
            resolve(blob);
          },
          (error) => {
            console.log(error);
            reject();
          }
        );
    });
  }
}
